import {Routes} from '@angular/router';
import {LoginComponent} from './components/auth/login/login.component';
import {PasswordForgottenComponent} from './components/auth/password-forgotten/password-forgotten.component';
import {ResetPasswordComponent} from './components/auth/reset-password/reset-password.component';
import {MainComponent} from './components/main/main.component';
import {authGuard} from './guards/auth.guard';
import {dashboardGuard} from './guards/dashboard.guard';
import {CustomersComponent} from './components/main/customers/customers.component';
import {CustomerComponent} from './components/main/customers/customer/customer.component';
import {ApiInterfacesComponent} from './components/main/api-interfaces/api-interfaces.component';
import {ApiInterfaceComponent} from './components/main/api-interfaces/api-interface/api-interface.component';
import {CustomerDataComponent} from "./components/main/customers/customer/customer-data/customer-data.component";
import {
  ApiInterfaceCustomersComponent
} from "./components/main/api-interfaces/api-interface/api-interface-customers/api-interface-customers.component";
import {
  ApiInterfaceDataComponent
} from "./components/main/api-interfaces/api-interface/api-interface-data/api-interface-data.component";
import {
  CustomerContactsComponent
} from "./components/main/customers/customer/customer-contacts/customer-contacts.component";
import {
  CustomerSalesPurchaseComponent
} from "./components/main/customers/customer/customer-sales-purchase/customer-sales-purchase.component";
import {
  CustomerAccountingComponent
} from "./components/main/customers/customer/customer-accounting/customer-accounting.component";
import {
  CustomerPartnerAssignmentComponent
} from "./components/main/customers/customer/customer-partner-assignment/customer-partner-assignment.component";

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [authGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'password-forgotten',
        component: PasswordForgottenComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: '',
    canActivate: [dashboardGuard],
    component: MainComponent,
    children: [
      {
        path: 'customers',
        component: CustomersComponent,
      },
      {
        path: 'customers/:id',
        component: CustomerComponent,
        children: [
          {
            path: '',
            component: CustomerDataComponent
          },
          {
            path: 'contacts',
            component: CustomerContactsComponent
          },
          {
            path: 'sales-purchase',
            component: CustomerSalesPurchaseComponent
          },
          {
            path: 'accounting',
            component: CustomerAccountingComponent
          },
          {
            path: 'partner-assignment',
            component: CustomerPartnerAssignmentComponent
          },
        ]
      },
      // {
      //   path: 'customers/:customerId/addresses/:id',
      //   component: AddressComponent
      // },
      {
        path: 'api-interfaces',
        component: ApiInterfacesComponent,
      },
      {
        path: 'api-interfaces/:id',
        component: ApiInterfaceComponent,
        children: [
          {
            path: '',
            component: ApiInterfaceDataComponent
          },
          {
            path: 'customers',
            component: ApiInterfaceCustomersComponent
          },
        ]
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
